/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

/**
 * The flat card used across detail screens.
 *
 * Extracted from TravelOrderDetailView so the call center renders the same
 * card rather than a fourth copy of it. White surface, hairline border, grey
 * header strip, no shadow -- the newer of the two visual grammars in this app.
 */

import React from "react";
import PropTypes from "prop-types";
import { Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

export default function InfoCard({ icon, title, headerAction, children, minHeight }) {
  return (
    <Card
      sx={{
        borderRadius: "12px",
        border: "1px solid #E8EDF5",
        boxShadow: "none",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1.25}
        sx={{ bgcolor: "#F4F6F9", borderBottom: "1px solid #E8EDF5" }}
      >
        <MDBox display="flex" alignItems="center" gap={1}>
          {icon && <Icon sx={{ fontSize: 20, color: "#5C6B82" }}>{icon}</Icon>}
          <MDTypography variant="button" fontWeight="bold" color="dark">
            {title}
          </MDTypography>
        </MDBox>
        {headerAction}
      </MDBox>
      <MDBox p={2.5} sx={{ minHeight }}>
        {children}
      </MDBox>
    </Card>
  );
}

InfoCard.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node.isRequired,
  headerAction: PropTypes.node,
  children: PropTypes.node,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

InfoCard.defaultProps = {
  icon: null,
  headerAction: null,
  children: null,
  minHeight: undefined,
};
